import { Container, Row, Col } from 'react-bootstrap';
import '../index.css';
import React, {  useState } from 'react';
import { fetchData } from './callAPI';


const Dashboard = () => {
  const [status, setStatus] = useState("search"); // Possible values: 'loading', 'search', 'result'
  const [query, setQuery] = useState(""); 
  const [result, setResult] = useState(""); 

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("loading")

    const response = await fetchData(query);
    if (response) {
      console.log("Data fetched successfully:", response);
      setResult(response)
      setStatus("result")
    } else {
      console.log("Failed to fetch data");
    }
  }  

  return (
    <Container  style={{ height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {status === "search" && (
          <Row className="w-100">
            <h2 style={{textAlign: 'center'}}>Search Wikipedia <strong>intelligently with AI</strong> *no effort required*</h2>
            <br />
            <br />
            <h6 style={{textAlign: 'center'}}>Wiki Ninja is a <strong>free service</strong> that allows you to quickly and intelligently search the world's knowledge base with AI</h6>
            <hr className="my-4" />
            <Col className="mb-3 d-flex justify-content-center">
              <form className="d-flex" style={{width: "80%", maxWidth: "500px"}} onSubmit={handleSubmit}>
                <textarea className="form-control" id="query" placeholder="Enter your question here" value={query} onChange={e => setQuery(e.target.value)} />
                <button type="submit" className="btn btn-primary ml-2" style={{marginLeft: "10px", backgroundColor: "#69B3FF", border: "none"}}>Search</button>
              </form>
            </Col>
          </Row>
        )}
        {status === "loading" && (
          <Row className="w-100 justify-content-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </Row>
        )}
        {status === "result" && (
          <div className="w-100">
          <Row className="w-100 justify-content-center" style={{height:"40vh"}}>
            <Col className="mb-3 d-flex justify-content-center">
              <textarea className="form-control" id="result" placeholder="Search results will appear here" value={result.text} readOnly />
            </Col>
          </Row>
          <Row className="w-100 justify-content-center">
            <a href={result.link} target="_blank" rel="noopener noreferrer" style={{marginTop: '10px', display: 'block', textAlign: 'center'}}>
              Read more here
            </a>
          </Row>
          </div>
        )}
    </Container>
  );
};

export default Dashboard;
